import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { Country, Region } from '@/types'

export const getRegions = async (country: Country): Promise<Region[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/regions/`, {
      params: {
        country,
      },
    })

    return response.data
  } catch (error) {
    throw new Error('Failed to fetch regions. Please login again.')
  }
}
